<div class="flex column height-100">
  <mat-accordion class="main-menu" displayMode="flat" *transloco="let t">
    <mat-action-list>
      @if (![9].includes(roleId) && ('dashboard.view' | capabilityCheck)) {
        <a mat-list-item routerLink="/user/dashboard" (click)="itemSelected.emit()">
          <mat-icon matListItemIcon class="material-symbols-outlined">dashboard</mat-icon>
          {{ t('menu.dashboard') }}
        </a>
      }
      @if ('company_document.view' | capabilityCheck) {
        <a mat-list-item routerLink="/user/company-documents" (click)="itemSelected.emit()">
          <mat-icon matListItemIcon class="material-symbols-outlined">policy</mat-icon>
          {{ t('menu.company_documents') }}
        </a>
      }
      @if (('equipment.supplier.inquiry' | capabilityCheck: true)) {
        <a mat-list-item routerLink="/equipment/supplier-cockpit" (click)="itemSelected.emit()">
          <mat-icon matListItemIcon class="material-symbols-outlined">dashboard</mat-icon>
          {{ t('views.equipment.supplier_cockpit.title') }}
        </a>
      }
      @if (canAccessNotifications) {
        <a mat-list-item routerLink="/notifications" (click)="itemSelected.emit()">
          <mat-icon matListItemIcon class="material-symbols-outlined">notifications</mat-icon>
          {{ t('menu.notifications') }}
        </a>
      }
      @if (('survey.create' | capabilityCheck) || ('survey.evaluate' | capabilityCheck)) {
        <a mat-list-item routerLink="/surveys" (click)="itemSelected.emit()">
          <mat-icon matListItemIcon class="material-symbols-outlined">poll</mat-icon>
          {{ t('menu.surveys') }}
        </a>
      }
    </mat-action-list>

    <!-- Fuel Efficiency -->
    @if ('report.emission.view' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title> {{ t('menu.fuel_efficiency.title') }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/visits-reports/emission-report" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">compost</mat-icon> {{ t('menu.fuel_efficiency.journeys') }}
          </a>
          <a mat-list-item routerLink="/vessel/past-track-map" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">map</mat-icon>
            {{ t('menu.fuel_efficiency.past_track') }}
          </a>
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Verwaltung -->
    @if ('view.manage.ui' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.certification.manage') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          @if ('equipment.edit' | capabilityCheck) {
            <a mat-list-item routerLink="/equipment/manage" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined">folder_managed</mat-icon>
              {{ t('views.psa.manage') }}
            </a>
            @if (!title.includes('GEFO')) {
              <a mat-list-item routerLink="/equipment/cost-centers" (click)="itemSelected.emit()">
                <mat-icon matListItemIcon class="material-symbols-outlined">account_balance</mat-icon>
                {{ t('menu.psa.cost_centers') }}
              </a>
            }
            @if ('equipment.import' | capabilityCheck) {
              <a mat-list-item routerLink="/equipment/catalogue-import" (click)="itemSelected.emit()">
                <mat-icon matListItemIcon class="material-symbols-outlined">system_update_alt</mat-icon>
                {{ t('views.psa.catalogue_import') }}
              </a>
            }
          }
          @if ('user.equipment.view' | capabilityCheck) {
            <a mat-list-item routerLink="/equipment/user" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">overview</mat-icon>
              {{ t('views.psa.overview_equipment') }}
            </a>
          }
          @if (('all' | capabilityCheck) || (('equipment.order.view.all' | capabilityCheck) && !('view.warehouse' | capabilityCheck: true))) {
            <a mat-list-item routerLink="/equipment/orders" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">shopping_bag</mat-icon>
              {{ t('views.psa.overview_orders') }}
            </a>
          }
          @if (('equipment.order.view.all' | capabilityCheck) && !('view.warehouse' | capabilityCheck: true)) {
            <a mat-list-item routerLink="/equipment/supplier-cockpit" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">monitoring</mat-icon>
              {{ t('views.equipment.supplier_cockpit.title') }}
            </a>
          }
          @if ('invoice.view' | capabilityCheck) {
            <a mat-list-item routerLink="/equipment/invoices" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">receipt_long</mat-icon>
              {{ t('menu.invoices') }}
            </a>
          }
          @if (('company_document.manage' | capabilityCheck) || ('document.view.all' | capabilityCheck)) {
            <a mat-list-item routerLink="/user/documents" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">description</mat-icon>
              {{ t('menu.user.documents') }}
            </a>
          }
          @if ('view.warehouse' | capabilityCheck) {
            <a mat-list-item routerLink="/equipment/bunkerstation-orders" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">local_gas_station</mat-icon>
              {{ t('views.equipment.bunker_orders.title') }}
            </a>
          }
          @if ('view.manage.warehouse' | capabilityCheck) {
            <a mat-list-item routerLink="/equipment/office-bunker-orders" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">local_post_office</mat-icon>
              {{ t('views.equipment.office_orders.title') }}
            </a>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Notbestand PSA -->
    @if ('asset.warehouse.deposit' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.emergency_stock') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/warehouse/equipment-stock" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">warehouse</mat-icon>
            {{ t('warehouse.emergency') }}
          </a>
          <a mat-list-item routerLink="/warehouse/equipment-stock-history" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">history</mat-icon>
            {{ t('warehouse.emergency_history') }}
          </a>
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Order -->
    @if (canOrderEquipment) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('views.psa.equipment') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/user/crew-member/order" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">shopping_cart</mat-icon>
            {{ t('views.psa.order') }}
          </a>
          <a mat-list-item routerLink="/user/crew-member/status" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">orders</mat-icon>
            {{ t('views.psa.order_status') }}
          </a>
          <a mat-list-item routerLink="/user/crew-member/myEquipment" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">apparel</mat-icon>
            {{ t('views.psa.my_equipment') }}
          </a>
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Personnel -->
    @if (canAccessPersonnel) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.personnel.title') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          @if ('hr.admin.planning.read' | hrCapabilityCheck) {
            <a mat-list-item routerLink="/personnel/shifts" (click)="selectItem()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">calendar_view_day</mat-icon>
              {{ t('menu.personnel.shifts') }}
            </a>
          }
          @if (('hr.admin.time.read' | hrCapabilityCheck) && hrFeatures.timeTracking()) {
            <a mat-list-item routerLink="/personnel/time-tracking" (click)="selectItem()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">schedule</mat-icon>
              {{ t('menu.personnel.time_tracking') }}
            </a>
          }
          @if ('hr.admin.vacation.manage' | hrCapabilityCheck) {
            <a mat-list-item routerLink="/personnel/vacation" (click)="selectItem()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">beach_access</mat-icon>
              {{ t('menu.personnel.vacation') }}
            </a>
          }

          @if ('hr.admin.personnel.read' | hrCapabilityCheck) {
            <button
              mat-list-item
              type="button"
              class="flyout-trigger"
              [class.flyout-trigger-open]="openFlyout === 'personnel'"
              cdkOverlayOrigin
              #personnelTrigger="cdkOverlayOrigin"
              (mouseenter)="showFlyout('personnel')"
              (mouseleave)="hideFlyout()"
              (click)="toggleFlyout('personnel')"
              (keydown.escape)="closeFlyout()"
            >
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">groups</mat-icon>
              {{ t('menu.personnel.group.management') }}
              <mat-icon matListItemMeta class="material-symbols-outlined flyout-chevron">chevron_right</mat-icon>
            </button>

            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="personnelTrigger"
              [cdkConnectedOverlayOpen]="openFlyout === 'personnel'"
              [cdkConnectedOverlayPositions]="flyoutPositions"
              (overlayOutsideClick)="closeOnOutsideClick($event, personnelTrigger)"
            >
              <div class="flyout mat-elevation-z4" (mouseenter)="keepFlyout()" (mouseleave)="hideFlyout()">
                <mat-action-list>
                  <a mat-list-item routerLink="/personnel/list" (click)="selectItem()">
                    <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">groups</mat-icon>
                    {{ t('menu.personnel.list') }}
                  </a>
                  <a mat-list-item routerLink="/personnel/documents" (click)="selectItem()">
                    <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">description</mat-icon>
                    {{ t('menu.personnel.documents') }}
                  </a>
                </mat-action-list>
              </div>
            </ng-template>
          }

          @if (canAccessAdministration) {
            <button
              mat-list-item
              type="button"
              class="flyout-trigger"
              [class.flyout-trigger-open]="openFlyout === 'administration'"
              cdkOverlayOrigin
              #administrationTrigger="cdkOverlayOrigin"
              (mouseenter)="showFlyout('administration')"
              (mouseleave)="hideFlyout()"
              (click)="toggleFlyout('administration')"
              (keydown.escape)="closeFlyout()"
            >
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">admin_panel_settings</mat-icon>
              {{ t('menu.personnel.group.administration') }}
              <mat-icon matListItemMeta class="material-symbols-outlined flyout-chevron">chevron_right</mat-icon>
            </button>

            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="administrationTrigger"
              [cdkConnectedOverlayOpen]="openFlyout === 'administration'"
              [cdkConnectedOverlayPositions]="flyoutPositions"
              (overlayOutsideClick)="closeOnOutsideClick($event, administrationTrigger)"
            >
              <div class="flyout mat-elevation-z4" (mouseenter)="keepFlyout()" (mouseleave)="hideFlyout()">
                <mat-action-list>
                  @if ('hr.admin.options' | hrCapabilityCheck) {
                    <a mat-list-item routerLink="/personnel/options" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">tune</mat-icon>
                      {{ t('menu.personnel.options') }}
                    </a>
                  }
                  @if ('hr.admin.personnel.read' | hrCapabilityCheck) {
                    <a mat-list-item routerLink="/personnel/management" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">settings</mat-icon>
                      {{ t('menu.personnel.management') }}
                    </a>
                    <a mat-list-item routerLink="/personnel/document-categories" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">topic</mat-icon>
                      {{ t('menu.personnel.document_categories') }}
                    </a>
                    <a mat-list-item routerLink="/personnel/planning-units" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">account_tree</mat-icon>
                      {{ t('menu.personnel.planning_units') }}
                    </a>
                  }
                  @if ('hr.admin.users' | hrCapabilityCheck) {
                    <a mat-list-item routerLink="/personnel/users" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">manage_accounts</mat-icon>
                      {{ t('menu.personnel.hr_users') }}
                    </a>
                  }
                  @if ('hr.admin.roles' | hrCapabilityCheck) {
                    <a mat-list-item routerLink="/personnel/roles" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">shield_person</mat-icon>
                      {{ t('menu.personnel.hr_roles') }}
                    </a>
                  }
                  @if ('hr.admin.planning.write' | hrCapabilityCheck) {
                    <a mat-list-item routerLink="/personnel/shift-planning" (click)="selectItem()">
                      <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">event_repeat</mat-icon>
                      {{ t('menu.personnel.shift_planning') }}
                    </a>
                  }
                </mat-action-list>
              </div>
            </ng-template>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Management -->
    @if ('visit.smv.view' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.management') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/management/smv/overview" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">running_with_errors</mat-icon>
            {{ t('menu.management.start_smv') }}
          </a>
          <a mat-list-item [routerLink]="['/management/visits', 'smv']" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">supervised_user_circle</mat-icon>
            {{ t('menu.management.smv_running') }}
          </a>
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Inspektor -->
    @if ('report.disturbance.view' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title> {{ t('site.disturbance_report') }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/visits-reports/disturbance-dashboard" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">dashboard</mat-icon>
            {{ t('menu.dashboard') }}
          </a>
          @if ('report.view' | capabilityCheck) {
            <a mat-list-item [routerLink]="['/visits-reports/start', 'disturbance-report']" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">start</mat-icon>
              {{ t('menu.site.start_report') }}
            </a>
          }
          <a mat-list-item routerLink="/visits-reports/disturbance-report" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">history</mat-icon>
            {{ t('menu.yard.claims') }}
          </a>
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Shipreports -->
    @if ('report.view.ui' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title> {{ t('menu.site.reports') }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item [routerLink]="['/visits-reports/start', 'reports']" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">start</mat-icon>
            {{ t('menu.site.start_report') }}
          </a>
          <a mat-list-item [routerLink]="['/visits-reports/history', 'reports']" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">history</mat-icon>
            {{ t('menu.certification.history') }}
          </a>
          @if ('report.position.view' | capabilityCheck) {
            <a mat-list-item [routerLink]="['/visits-reports/position-report', 7, 'reports']" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">share_location</mat-icon>
              {{ t('menu.site.position_report') }}
            </a>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Shipvisits -->
    @if ('visit.view' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title> {{ t('menu.site.visits') }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item [routerLink]="['/visits-reports/start', 'visits']" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">start</mat-icon>
            {{ t('menu.site.start_visit') }}
          </a>
          <a mat-list-item [routerLink]="['/visits-reports/history', 'visits']" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">history</mat-icon>
            {{ t('menu.certification.history') }}
          </a>
          @if ('process.view.captainEvaluations' | capabilityCheck) {
            <a mat-list-item [routerLink]="['/visits-reports/captain-evaluation']" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">monitoring</mat-icon>
              {{ t('menu.captain-evaluation') }}
            </a>
          }
          @if ('inspection.view' | capabilityCheck) {
            <a mat-list-item routerLink="/visits-reports/inspections" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">fact_check</mat-icon>
              {{ t('menu.inspections') }}
            </a>
          }
          @if ('visit.location.map.view' | capabilityCheck) {
            <a mat-list-item [routerLink]="['/visits-reports/visit-location-map']" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">map</mat-icon>
              {{ t('menu.site.visit_location_map') }}
            </a>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Calendar -->
    @if ('calendar.view' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('modules.calendar.title') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item [routerLink]="`/calendar/calendar/${(currentDate | date: 'yyyy-MM-dd')}`" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">event</mat-icon>
            {{ t('menu.certification.calendar') }}
          </a>
          <!-- <a disabled mat-list-item (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">summarize</mat-icon>
            {{ t('modules.calendar.evaluation') }}
          </a> -->
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- User -->
    @if (('view.user.list' | capabilityCheck) || ('view.user.onboarding' | capabilityCheck)) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.user.title') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          @if ('view.user.list' | capabilityCheck) {
            <a mat-list-item routerLink="/user/list" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">engineering</mat-icon>
              <span class="flex-grow-1">{{ t('menu.user.manage') }}</span>
            </a>
          }
          @if (('user.edit' | capabilityCheck) || ('asset.edit' | capabilityCheck)) {
            <a mat-list-item routerLink="/user/functions" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">badge</mat-icon>
              <span class="flex-grow-1">{{ t('menu.user.functions') }}</span>
            </a>
          }
          @if ('user.group.edit' | capabilityCheck) {
            <a mat-list-item routerLink="/user/groups" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">groups</mat-icon>
              <span class="flex-grow-1">{{ t('menu.user.groups') }}</span>
            </a>
          }
          @if ('view.user.onboarding' | capabilityCheck) {
            <a mat-list-item routerLink="/user/onboarding" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">checklist</mat-icon>
              <span class="flex-grow-1">{{ t('menu.user.onboarding') }}</span>
            </a>
          }
          @if ('all' | capabilityCheck) {
            @if (!production) {
              <a mat-list-item routerLink="/user/roles" (click)="itemSelected.emit()">
                <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">group</mat-icon>
                {{ t('menu.user.role') }}
              </a>
            }
            <a mat-list-item routerLink="/user/documents" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">description</mat-icon>
              {{ t('menu.user.documents') }}
            </a>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Assets -->
    @if ('asset.view.ui' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.assets.title') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          @if ('asset.takeover' | capabilityCheck) {
            <a mat-list-item routerLink="/assets/take" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">qr_code_scanner</mat-icon>
              {{ t('menu.assets.transfer') }}
            </a>
          }
          @if ('asset.view' | capabilityCheck) {
            <app-filter-list-menu-outlet (itemSelected)="itemSelected.emit()" for="/assets/table" menuEntry="Assets" />
          }
          @if ('asset.edit' | capabilityCheck) {
            <a mat-list-item routerLink="/assets/list" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">dynamic_feed</mat-icon>
              {{ t('menu.assets.overview') }}
            </a>
          }
          @if ('asset.view.map' | capabilityCheck) {
            <a mat-list-item routerLink="/vessel/vessel-map" [queryParams]="{ type: 'asset' }" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">map</mat-icon>
              {{ t('menu.assets.map') }}
            </a>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Site -->
    @if ('site.view' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title>
            {{ t('menu.site.title') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          @if ('site.view' | capabilityCheck) {
            <app-filter-list-menu-outlet (itemSelected)="itemSelected.emit()" for="/vessel/table" menuEntry="Ships" />
          }
          @if ('site.edit' | capabilityCheck) {
            <a mat-list-item routerLink="/assets/list/2" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">directions_boat</mat-icon>
              {{ t('menu.site.vessel_management') }}
            </a>
          }
          @if ('geofence.view' | capabilityCheck) {
            <a mat-list-item routerLink="/vessel/geofences" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">fence</mat-icon>
              {{ t('menu.site.geofences') }}
            </a>
          }
          @if ('view.vessel.map' | capabilityCheck) {
            <a mat-list-item routerLink="/vessel/vessel-map" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">map</mat-icon>
              {{ t('menu.site.map') }}
            </a>
          }
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- BRA -->
    @if ('bra.view.map' | capabilityCheck) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title> {{ t('menu.bra.title') }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/vessel/vessel-map" [queryParams]="{ type: 'bra' }" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">map</mat-icon>
            {{ t('vessel_map.bra_map') }}
          </a>
          <a mat-list-item routerLink="/bra/overview" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">overview</mat-icon>
            {{ t('common.overview') }}
          </a>
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Werftmodul -->
    @if (('yard.view' | capabilityCheck) || ('yard.subcontractor.view' | capabilityCheck)) {
      <mat-expansion-panel>
        <mat-expansion-panel-header expandedHeight="48px">
          <mat-panel-title> {{ t('menu.yard.title') }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="/yard/dashboard" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">dashboard</mat-icon>
            {{ t('menu.dashboard') }}
          </a>
          <a mat-list-item routerLink="/yard/claims" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">history</mat-icon>
            {{ t('menu.yard.claims') }}
          </a>
          @if ('yard.view' | capabilityCheck) {
            <a mat-list-item routerLink="/yard/subcontractors" (click)="itemSelected.emit()">
              <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">groups</mat-icon>
              {{ t('menu.yard.subcontractors') }}
            </a>
          }
          <!-- currently unused, will be implemented later -->
          <!-- <a mat-list-item routerLink="/yard/nachtraege" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">find_in_page</mat-icon>
            {{ t('menu.yard.addenda') }}
          </a>
          <a mat-list-item routerLink="/yard/abrechnung" (click)="itemSelected.emit()">
            <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">receipt_long</mat-icon>
            {{ t('menu.yard.billing') }}
          </a> -->
        </mat-action-list>
      </mat-expansion-panel>
    }

    <!-- Emergency -->
    @if (![5, 9, 12, 20].includes(roleId) && (('emergency.view' | capabilityCheck) || ('emergency.view.sea' | capabilityCheck))) {
      @for (menuItem of staticPageMenu | keyvalue; track menuItem.key) {
        <mat-expansion-panel>
          <mat-expansion-panel-header expandedHeight="48px">
            <mat-panel-title>
              {{ menuItem.key }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-action-list>
            @for (item of menuItem.value; track item) {
              @if (item.action) {
                <a
                  mat-list-item
                  (click)="handleStaticPageAction(item); itemSelected.emit()"
                  (keydown.enter)="handleStaticPageAction(item); itemSelected.emit()"
                  tabindex="0"
                >
                  <mat-icon matListItemIcon class="material-symbols-outlined margin-xxs-right">{{ item.menuItemIcon }}</mat-icon>
                  {{ item.menuItem }}
                </a>
              }
            }
          </mat-action-list>
        </mat-expansion-panel>
      }
    }
  </mat-accordion>

  <div class="flex-grow-1"></div>
  <div class="sidemenu-footer hidden-sm pb-2">
    <div class="flex justify-center align-center">
      <img src="/assets/logo/logo_default_small.png" height="20px" alt="Application logo" />
      Version {{ version }}
    </div>
  </div>
</div>
